import { createTranslations } from "@moodys/mdc-frontend.utils.translation";

import en from "./en.json";
import ja from "./ja.json";
import zh from "./zh-cn.json";

export const {
  useTranslation: useFooterTranslation,
  TranslateHTML: TranslateFooterHTML,
} = createTranslations({ resources: { en, ja, zh } });

export type TranslationKey = keyof typeof en.translation;
